import React from 'react';
import { Box, Link, Typography } from '@mui/material';

const DeveloperCredit = () => {
  const developerName = process.env.REACT_APP_DEVELOPER_NAME || 'Esteban Lucero';
  const developerBrand = process.env.REACT_APP_DEVELOPER_BRAND || 'Appteck';
  const developerUrl = process.env.REACT_APP_DEVELOPER_URL || 'https://appteck.com.ar';

  return (
    <Box className="developer-credit">
      <Typography variant="caption" component="span">
        Diseño y desarrollo por {developerName} ·{' '}
        <Link href={developerUrl} target="_blank" rel="noopener" color="inherit" underline="hover">
          {developerBrand}
        </Link>
      </Typography>
    </Box>
  );
};

export default DeveloperCredit;
